import tw from 'twin.macro';

export const CustomerLogo = tw.img`w-16 h-16 border-4 border-solid rounded-md max-w-customer-logo max-h-customer-logo border-background bg-background`;
